import { useSelector } from 'react-redux'
import { RootState } from '@/store/store'
import { Controls, Player } from "@lottiefiles/react-lottie-player"
import animationData from "@/animation.json"

export function GlobalLoader({ isStartup }: {isStartup?: boolean}) {
  const { showLoader, pendingRequests } = useSelector(
    (state: RootState) => state.loader
  )

  if (!isStartup && (!showLoader )) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/20 z-[100003]">
      <Player autoplay loop src={animationData} className="w-[80px]">
        <Controls visible={false} buttons={["play", "repeat", "frame", "debug"]} />
      </Player>
    </div>
  )
}